module.exports = __webpack_public_path__ + "img/frame4.6d15173a.png";